import { FC } from 'react'
import { createPortal } from 'react-dom'
import { Box, useTheme } from '@mui/material'

import { LessonBlockContent } from './LessonBlockContent'
import { getStatusBackgroundStyle } from './styles'
import { DragState } from './useLessonDrag'

type DragGhostProps = {
  dragState: DragState
}

export const DragGhost: FC<DragGhostProps> = ({ dragState }) => {
  const theme = useTheme()

  if (dragState.phase !== 'dragging') {
    return null
  }

  const { lesson, ghostX, ghostY, offsetX, offsetY, width, height } = dragState
  const color = lesson.product?.color ?? '#E0E0E0'
  const paidRatio = (() => {
    const bookings = lesson.bookings
    if (bookings.length === 0) return undefined
    const byCustomer = new Map<string, boolean>()
    for (const b of bookings) {
      const prev = byCustomer.get(b.customerId)
      byCustomer.set(b.customerId, (prev ?? true) && !!b.receiptId)
    }
    const customers = [...byCustomer.values()]
    const paidCount = customers.filter(Boolean).length
    if (paidCount === 0 || paidCount === customers.length) return undefined
    return paidCount / customers.length
  })()
  const bgStyle = getStatusBackgroundStyle(theme, lesson.status, lesson.paymentStatus, false, paidRatio)

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        left: ghostX - offsetX,
        top: ghostY - offsetY,
        width,
        height,
        pointerEvents: 'none',
        zIndex: 9999,
        ...bgStyle,
        borderTop: `4px solid ${color}`,
        borderRadius: 1,
        boxShadow: 3,
        display: 'flex',
        alignItems: 'center',
        py: 0.5,
        px: 1,
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <LessonBlockContent lesson={lesson} />
    </Box>,
    document.body,
  )
}
